// extracted by mini-css-extract-plugin
export default {"root":"ConfirmDialog_root__Nwp2e"};